var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.routinesSlider.active)?_c('RoutineCardsSlider',_vm._b({},'RoutineCardsSlider',_vm.routinesSlider,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }